define('services/myservices/add-product-alliance.service',['app', 'mainCons'], function(app, mainCons) {
    return app.factory('addProduct4Alliance',['$q','UserInfo','myServicesPackage',function($q,UserInfo,myServicesPackage){
        /**
         * 联盟提供给业务部件跨iframe调用添加产品信息
         * @param prodType
         * @param serviceItem
         * @param needParentType 是否展示父类型下拉框
         */
        function addProduct(prodType,serviceItem,needParentType){
            var defer = $q.defer();
            if (!prodType) {
                defer.reject();
                return defer.promise;
            }
            UserInfo.promise().then(function(userInfo){
                var Model = {
                    selected:{prodType:prodType},
                    serviceItem:serviceItem,
                    needParentType:needParentType
                };
                myServicesPackage.newProduct(Model,userInfo).then(function (res) {
                    defer.resolve(res);
                }).catch(function(){
                    defer.reject();
                });
            }).catch(function(){
                defer.reject();
            });
            return defer.promise;
        }
        return {
            addProduct:addProduct
        }
    }]);
});
